import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=6631ccfa&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=6631ccfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6631ccfa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6631ccfa')) {
      api.createRecord('6631ccfa', component.options)
    } else {
      api.reload('6631ccfa', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=6631ccfa&scoped=true&", function () {
      api.rerender('6631ccfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Zpk3kgy1cvL6/JS/teamMember.vue"
export default component.exports